import axios from 'axios';
import { Game } from '../types/game';

const RAPIDAPI_KEY = process.env.REACT_APP_RAPIDAPI_KEY;
const RAPIDAPI_HOST = process.env.REACT_APP_RAPIDAPI_HOST;

if (!RAPIDAPI_KEY || !RAPIDAPI_HOST) {
  console.error('Не заданы REACT_APP_RAPIDAPI_KEY или REACT_APP_RAPIDAPI_HOST');
}

export const gamesApi = {
  getAllGames: async (): Promise<Game[]> => {
    const options = {
      method: 'GET',
      url: `https://${RAPIDAPI_HOST}/api/games`,
      headers: {
        'X-RapidAPI-Key': RAPIDAPI_KEY,
        'X-RapidAPI-Host': RAPIDAPI_HOST,
      },
    };
    try {
      const response = await axios.request(options);
      return response.data.slice(0, 30);
    } catch (error) {
      console.error('Error fetching games:', error);
      return [];
    }
  },

  getGameById: async (id: number): Promise<Game | null> => {
    const options = {
      method: 'GET',
      url: `https://${RAPIDAPI_HOST}/api/game`,
      params: { id: id },
      headers: {
        'X-RapidAPI-Key': RAPIDAPI_KEY,
        'X-RapidAPI-Host': RAPIDAPI_HOST,
      },
    };
    try {
      const response = await axios.request(options);
      return response.data;
    } catch (error) {
      console.error('Error fetching game:', error);
      return null;
    }
  },

  searchGames: async (searchTerm: string): Promise<Game[]> => {
    const options = {
      method: 'GET',
      url: `https://${RAPIDAPI_HOST}/api/games`,
      headers: {
        'X-RapidAPI-Key': RAPIDAPI_KEY,
        'X-RapidAPI-Host': RAPIDAPI_HOST,
      },
    };
    try {
      const response = await axios.request(options);
      const games = response.data.slice(0, 30);
      return games.filter((game: Game) =>
        game.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        game.short_description.toLowerCase().includes(searchTerm.toLowerCase())
      );
    } catch (error) {
      console.error('Error searching games:', error);
      return [];
    }
  },
};